import { Box } from '@mui/system'
import { groupBy } from 'lodash'
import PropTypes from 'prop-types'

import PartCategoryPanel from './PartCategoryPanel/PartCategoryPanel'

const PartsList = ({ nqp, onPartSelected, parts, selectedPart }) => {
    return parts ? (
        <Box data-testid="parts-list-container">
            {Object.entries(groupBy(parts, (part) => part.category)).map(([category, categoryParts]) => (
                <PartCategoryPanel
                    categoryName={category}
                    expanded={selectedPart ? selectedPart.category === category : false}
                    key={category}
                    nqp={nqp}
                    parts={categoryParts}
                    selectedPart={selectedPart}
                    onPartSelected={onPartSelected}
                />
            ))}
        </Box>
    ) : null
}

PartsList.propTypes = {
    nqp: PropTypes.bool,
    parts: PropTypes.array,
    selectedPart: PropTypes.object,
    onPartSelected: PropTypes.func,
}

export default PartsList
